import { render, staticRenderFns } from "./insPatientSelection.vue?vue&type=template&id=f24af814&"
import script from "./insPatientSelection.vue?vue&type=script&lang=js&"
export * from "./insPatientSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports